module.exports = __webpack_public_path__ + "img/excellence_small.8286248c.png";